export default __webpack_public_path__ + "static/media/streak-base-stat-icon.ba45f6c2.svg";